import type { DictionaryItemProps } from '../lib/types';
import { isNullOrUndefined } from '@r-and-a-shared-ui/utils';

export const tryGetDictionaryItemValue = (
  dictionaryItems: DictionaryItemProps[] | undefined,
  key: string,
): string | undefined => {
  if (isNullOrUndefined(dictionaryItems)) {
    return undefined;
  }
  return dictionaryItems.find(item => item.key === key)?.value;
};
export type ErrorSetterDetails = {
  setError: ((...args: any[]) => any) | undefined;
  errorKey: string;
  statusCode: string;
  errorsDictionary: DictionaryItemProps[] | undefined;
  defaultMessage: string;
};
export const setServerError = (errorSetter: ErrorSetterDetails) => {
  const { errorsDictionary, errorKey, defaultMessage, setError, statusCode } =
    errorSetter;
  const errMessage =
    tryGetDictionaryItemValue(errorsDictionary, errorKey) || defaultMessage;
  if (!isNullOrUndefined(setError)) {
    setError('root.serverError', {
      type: statusCode,
      message: errMessage,
    });
  }
};
export const hasMeaningfulHtml = (html?: string): boolean => {
  if (!html) return false;
  const cleaned = html
    .replace(/<p>\s*(?:<br\s*\/?>|&nbsp;|\u00A0|\s)*<\/p>/gi, '')
    .replace(/<br\s*\/?>/gi, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/<[^>]*>/g, '')
    .trim();
  return cleaned.length > 0;
};
